import { render, staticRenderFns } from "./EventBuilder.vue?vue&type=template&id=51af65b2&scoped=true"
import script from "./EventBuilder.vue?vue&type=script&lang=js"
export * from "./EventBuilder.vue?vue&type=script&lang=js"
import style0 from "./EventBuilder.vue?vue&type=style&index=0&id=51af65b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51af65b2",
  null
  
)

export default component.exports